import React from 'react'
import { Helmet } from "react-helmet"
import { Link, graphql } from 'gatsby'
import Img from "gatsby-image"
import Seo from '../components/seo'
import NavMobile from '../components/nav_mobile'
import BackgroundImage from 'gatsby-background-image'
import GoogleReviews from '../components/google_reviews_slider'
import Copyright from '../components/copyright'
import Partners from '../components/partners'

export default ({ data }) => {
    const entry = data.markdownRemark
    const { frontmatter } = entry
    const heroFluid = frontmatter.image?.childImageSharp?.fluid
    const sideFluid = frontmatter.side_image?.childImageSharp?.fluid
    const titleBlock = (
        <div className="title__gradient">
            <div className="layout__container">
                <div className="layout__wide title center">
                    <h1>{frontmatter.heading}</h1>
                </div>
            </div>
        </div>
    )
    return (
        <div className="page">
            <Helmet>
                <link href="https://fonts.googleapis.com/css2?family=Oswald&display=swap" rel="stylesheet" />
            </Helmet>
            <Seo title={frontmatter.page_title} description={frontmatter.meta_description} image="" pathname={entry.fields.slug} />
            <NavMobile />
            <div className="layout">
                {heroFluid ? (
                    <BackgroundImage fluid={heroFluid} backgroundColor={`#ffffff`}>
                        {titleBlock}
                    </BackgroundImage>
                ) : (
                    titleBlock
                )}
            </div>
            <div className="layout grey">
                <div className="layout__container">
                    <div className="layout__wide">
                        <nav className="breadcrumb">
                            <p><Link to='/'>Home</Link> &nbsp;&rsaquo;&nbsp; <Link to={`/${frontmatter.section_url}/`}>{frontmatter.section}</Link> &nbsp;&rsaquo;&nbsp; <strong>{frontmatter.title}</strong></p>
                        </nav>
                    </div>
                </div>
            </div>
            <div className="layout body">
                <div className="layout__container">
                    <div className="layout__wide">
                        <div className="grid grid__2-1 grid__gap--48 text">
                            <div>
                                <div dangerouslySetInnerHTML={{ __html: entry.html }} />
                                <Link to="/contact" title="Contact" className="btn btn__large btn__margin">Request quote &nbsp;►</Link>
                                
                            </div>
                            <div className="aside">
                                {sideFluid && (
                                    <Img fluid={sideFluid} alt={frontmatter.side_heading || ''} />
                                )}
                                {frontmatter.side_heading && <h3>{frontmatter.side_heading}</h3>}
                                <ul>
                                    {(frontmatter.side_text ?? []).map( (item, i) => (
                                        <li key={i}>{item.text}</li>
                                    ))}
                                </ul>
                                <figure className="master_painter">
                                    <a href="https://www.masterpainters.co.nz/" title="Master Painters" rel="nofollow noopener"><Img fixed={data.master_painter.childImageSharp.fixed} alt='Master Painter' /></a>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <GoogleReviews />
            <Partners />
            <Copyright />
        </div>
    )
}

export const query = graphql`
	query($slug: String!) {
        master_painter: file(relativePath: { eq: "MP_Logo.jpg" }) {
            childImageSharp {
                fixed(width: 200) {
                    ...GatsbyImageSharpFixed
                  }
            }
        }
		markdownRemark( fields: { slug: { eq: $slug } }) {
			frontmatter {
                section
                section_url
                title
				page_title
                meta_description
                heading
                image {
                    childImageSharp {
                        fluid(maxWidth: 1280) {
                            ...GatsbyImageSharpFluid_withWebp
                        }
                    }
                }
                side_heading
                side_text {
                    text
                }
                side_image {
                    childImageSharp {
                        fluid(maxWidth: 640, maxHeight: 480) {
                            ...GatsbyImageSharpFluid_withWebp
                        }
                    }
                }
			}
			fields {
				slug
			}
			html
		}
	}
`